import Dexie from 'dexie';

const oceandb = new Dexie('OceabDB');
oceandb.version(1).stores({ user: '++id' });

export async function addUser(user) {
    try {
        return oceandb.table('user')
            .add({...user, darkMode: false });
    }
    catch (err) {
        console.error(err);
    }
}

export async function getUser() {
    try {
        const user = await oceandb.table('user')
            .toArray();
        return user[0];
    }
    catch (err) {
        console.error(err);
    }
}

export async function removeUser(id) {
    try {
        await oceandb.table('user').clear();
        // await oceandb.table('user')
        //     .delete(id);
    }
    catch (err) {
        console.error(err);
    }
}

export async function updateUserData(id, data) {
    try {
        await oceandb.table('user')
            .update(id, { userCy: data.userCy, userCyName: data.userCyName });
    }
    catch (err) {
        console.error(err);
    }
}

export async function updateUserDataBranch(id, data) {
    try {
        await oceandb.table('user')
            .update(id, { branches: data.branch, allCy: data.cy, userCy: null, userCyName: null });
    }
    catch (err) {
        console.error(err);
    }
}

export async function updateUserDataDarkMode(id, data) {
    try {
        await oceandb.table('user')
            .update(id, { darkMode: data });
    }
    catch (err) {
        console.error(err);
    }
}

const OTGCONTENT = new Dexie('OTGCONTENT');
OTGCONTENT.version(1).stores({ contents: '++id' });

export async function addContent(data) {
    try {
        return OTGCONTENT.table('contents')
            .add(data);
    }
    catch (err) {
        console.error(err);
    }
}
export async function getContent() {
    try {
        const contents = await OTGCONTENT.table('contents')
            .toArray();
        return contents;
    }
    catch (err) {
        console.error(err);
    }
}